import { IDENTITY_CONFIG, METADATA_OIDC } from "./authConst";
import { UserManager, WebStorageStateStore, Log } from "oidc-client";

export default class AuthService {
    UserManager;

    constructor() {
        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
            metadata: {
                ...METADATA_OIDC
            }
        });

        localStorage.setItem("idenity", JSON.stringify(IDENTITY_CONFIG));
        localStorage.setItem("meta", JSON.stringify(METADATA_OIDC));
        // Logger
        Log.logger = console;
        Log.level = Log.DEBUG;
        this.UserManager.events.addUserLoaded(() => {
            if (window.location.href.indexOf("/dashboard") !== -1) {
                this.navigateToScreen();
            }
        });
        this.UserManager.events.addSilentRenewError((e) => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.logout();
        });
    }

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then(() => {
            "";
        });
    };


    getUser = async () => {
        const user = await this.UserManager.getUser();
        if (!user) {
            return await this.UserManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };


    signinRedirect = () => {
        localStorage.setItem("redirectUrl", window.location.href);
        this.UserManager.signinRedirect({});

    };


    navigateToScreen = () => {
        window.location.replace("/dashboard");
    };

    isAuthenticated = () => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${'https://datamaps-idp-dev.auth.us-east-1.amazoncognito.com'}:${'5j9qi6caivn21lkunocp4v4gh1'}`))

        return (!!oidcStorage && !!oidcStorage.access_token)

    }

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user) => {
                console.log("signed in", user);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        }).then(() => { this.UserManager.removeUser() })
        .then(() => { this.user = null; })
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        localStorage.removeItem('bearer-token');
        sessionStorage.clear();
        window.location.replace('https://datamaps-dev.goodresearch.com/signout');
        this.UserManager.signoutRedirectCallback()
            .then(() => { this.UserManager.removeUser() })
            .then(() => { this.user = null; })

        this.UserManager.clearStaleState();
    };
}
